/**
 * L'état d'une permission, quand le navigateur veut bien le dire.
 *
 * Cette API n'est pas fiable partout — Firefox et Safari ne connaissent pas
 * toujours `camera` ni `microphone` — et c'est d'avoir traité son échec comme un
 * refus qui mettait ces navigateurs au rouge avec un matériel sain. On ne s'en
 * sert donc jamais pour conclure à un refus : seulement pour éviter d'ouvrir une
 * fenêtre inutilement, et pour distinguer deux situations que `getUserMedia`
 * rend identiques. Son silence veut dire « je ne sais pas », pas « non ».
 */
export async function permissionState(name) {
    try {
        if (!navigator.permissions?.query) return null
        const { state } = await navigator.permissions.query({ name })
        return state // "granted" | "denied" | "prompt"
    } catch (error) {
        return null
    }
}
